export enum LoginTextElement {
  FAQ = 'See our login FAQs here.',
  RecoverPassword = 'Recover your password here.',
  PrivacyPolicy = 'See our User ID Privacy Policy here.',
  Request = 'Request a free trial of IPO Intelligence here.',
}
